import React from 'react';

export function MHeader ({item, pageList}){
    //console.log(item)
    return(
        <>
        <li>
            <small className="text-danger">[{item.sequence}]</small>
            {item.menuName} 
            <small className="text-success">{item.menuId}</small>
        </li>
        <ol>
        {
            item.items.map((title, index) =>(
                <MTitle key={"H+"+index+item.menuId} title={title} pageList={pageList} />
            ))
        }
        </ol>
        <hr></hr>
        </>
    )
}

function MTitle({title, pageList}){
    return(
        <>
        <li>
            <small className="text-danger">[{title.sequence}]</small>
            {title.menuName} 
            <small className="text-success">{title.menuId}</small>
        </li>
        {
            title.items.length === 0 ? <></>:<MTitleMap title={title} pageList={pageList}  />
        }
        </>
    )
}

function MTitleMap({title, pageList}){
    return(
    <ol>
    {
        title.items.map((item, index) =>(
            <MName key={"MT_"+index+title.menuId} item={item} pageList={pageList} />
        ))
    }
    </ol>
    )
}

function MName({item, pageList}){
    var html;
    
    if(pageList !== undefined){        
        var filterEmpty = pageList.filter(function(pageItem, index, array){
            return pageItem.menuId === item.menuId;
        });
        if(filterEmpty.length > 0){
            /*
            filterEmpty.map((filterItem, index)=>(
                html.push( <small className="text-yellow">{filterItem.pageName}</small>)
            ))
            */
            html = <GetTable key={"TG_"+item.menuId} filterEmpty={filterEmpty} />;
        }
    }
    return(
        <>
        <li>
            <small className="text-danger">[{item.sequence}]</small>
            {item.menuName} 
            <small className="text-success">{item.menuId}</small>&nbsp;
            <small className="text-warning">{item.link}</small>
        </li>
        {
            html
        }
        </>
    )
}

export function GetTable({filterEmpty}){
    return(
    <div className="box box-success">
            <div className="box-body no-padding">
              <table className="table table-condensed">
                <tbody>
                    {/*
                    <tr>
                  <th>名稱</th>
                  <th>說明</th>
                  <th>連結</th>
                </tr>
                     */}
                {
                    filterEmpty.map((filterItem, index)=>(
                        <GetTr key={"GT"+index+filterEmpty.id} pageName={filterItem.pageName} pageDescription={filterItem.pageDescription} pageLink={filterItem.pageLink} sequence={filterItem.sequence}/>
                    ))
                }
                
              </tbody></table>
            </div>
          </div>
          )
}


export function GetTr({pageName, pageDescription, pageLink, sequence}){
    return(
        <tr>
            <td>{pageName}</td>
            <td>{pageDescription}</td>
            <td>{pageLink}</td>
            {/*<td>{sequence}</td>*/}
        </tr>
    )
}
